export const MAIN_CONTENT_ID = 'main-content';

export const scrollToTop = (): (() => void) => {
  const applyScroll = (): void => {
    const mainContent = document.getElementById(MAIN_CONTENT_ID);

    if (mainContent) {
      mainContent.scrollTop = 0;
    }

    window.scrollTo(0, 0);
  };

  applyScroll();

  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  const rafId = requestAnimationFrame(() => {
    timeoutId = setTimeout(applyScroll, 0);
  });

  return () => {
    cancelAnimationFrame(rafId);
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
  };
};
